import network from '@/utils/network'

/**
 * Récupère la liste des devices
 * @returns {Promise<>}
 */
export const getUserDevices = async () => {
  const r = await network.get(`user/devices`)
  return r.data
}

/**
 * Soumet / met à jour un device
 * @returns {Promise<>}
 */
export const postUserDevice = async (device) => {
  const r = await network.post(`user/device`, device)
  return r.data
}

/**
 * Supression d'un token
 * @returns {Promise<>}
 */
export const deleteUserDevice = async (token) => {
  const r = await network.delete(`user/device/${token}`)
  return r.data
}
